export default __webpack_public_path__ + "static/media/emotionlogic.c701e4a6.svg";